import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import type { ReferralType } from '@wix/da-bi/pkg/constants';
import { SellerScreen } from './redux/types';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_seller_shared" */
        './redux/SellerModuleLoader'
      )
  )
);

const LoadableSingleSellModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_seller_shared" */
        './SingularSellerModal'
      )
  )
);

const LoadableBatchSellModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_seller_shared" */
        './BatchSellerModal'
      )
  )
);

interface Props {
  deviations: PapiDeviation[];
  onRequestClose: () => void;
  initialScreen?: SellerScreen;
  extraScreenProps?: any;
  biReferralInfo?: ReferralType;
}

const SellerModalLoadable: React.FC<Props> = ({ deviations, ...rest }) => (
  <ErrorBoundary debugComponent="SellerModalLoadable">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableRedux />
      {deviations.length === 1 ? (
        <LoadableSingleSellModal deviation={deviations[0]} {...rest} />
      ) : (
        <LoadableBatchSellModal deviations={deviations} {...rest} />
      )}
    </Suspense>
  </ErrorBoundary>
);
SellerModalLoadable.displayName = 'SellerModalLoadable';

export default SellerModalLoadable;
